/** Shared feed/spindle override carousel options — used by OverridePanel and the preview modal. */

export const FEED_OVERRIDE_OPTIONS = [
  '0%',
  '25%',
  '50%',
  '75%',
  '100%',
  '125%',
  '150%',
  '175%',
  '200%',
];
export const SPINDLE_OVERRIDE_OPTIONS = [
  '0%',
  '25%',
  '50%',
  '75%',
  '100%',
  '125%',
  '150%',
  '175%',
  '200%',
];

export const FEED_PERCENTS = FEED_OVERRIDE_OPTIONS.map((o) => parseInt(o, 10));
export const SPINDLE_PERCENTS = SPINDLE_OVERRIDE_OPTIONS.map((o) => parseInt(o, 10));

/** Index of the option closest to the machine's read-back value. */
export function nearestIndex(percents: number[], value: number): number {
  let best = 0;
  let bestDist = Infinity;
  for (let i = 0; i < percents.length; i++) {
    const dist = Math.abs((percents[i] ?? 0) - value);
    if (dist < bestDist) {
      bestDist = dist;
      best = i;
    }
  }
  return best;
}
